import { createAsyncApi } from "@app/state/partials/async"
import { createToast } from "@/modules/toast-message"
import { computed, ref } from 'vue'
import { dataGet, dataSet } from '@app/helpers/dot'


export default function createEventData(){
    const api = createAsyncApi(
        'bt_get_event_by_id',
        'GET',
        {
            responseKey : 'event.data',
            callbacks: {
                onError: (data, original, errors) => {
                    if(data.code === 404){
                        createToast("This event could not be found", "error")
                    } else {
                        createToast("Couldn't load event, please try again", "error")
                    }
                }
            },
            onDataRetrieved: (data) => {
                data.event.data.html = data.html

                return data
            }
        }
    )

    const ticket = ref(null)

    const availableWorkshops = computed(() => {
        if(!ticket.value?.id){
            return []
        }

        console.log(api.details.value)

        return (api.details.value.workshops ?? []).filter(
            (workshop) => (workshop.timeslot_ids ?? []).every(
                (timeslot) => (ticket.value?.timeslot_ids ?? [])
                    .find((ticketTimeslot) => ticketTimeslot == timeslot) !== undefined
            )
        )
    })

    return {
        ...api,

        ticket      : ticket,
        lowestPrice : ref(null),

        availableWorkshops: availableWorkshops,
        groupedWorkshops: computed(() => {})
    }
}